import React from 'react';
import { Navigate, Outlet } from 'react-router';
import { useAuth } from '../context/AuthProvider';

export const UnprotectedRoute: React.FC = () => {
  const { auth } = useAuth();

  if (auth?.user) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};
